export const REVIEW_APPROVED = 'APPROVED';
export const REVIEW_REJECTED = 'REJECTED';
export const REVIEW_PENDING = 'PENDING';
export const REVIEW_DEFERRED = 'DEFERRED';

export interface ReviewNotice {
  known: boolean;
  title: string;
  detail: string;
  blocking: boolean;
}

function matchKey(decision: string | null | undefined): string | null {
  if (typeof decision !== 'string') return null;
  const trimmed = decision.trim();
  return trimmed.length > 0 ? trimmed.toUpperCase() : null;
}

export function isReviewBlocked(decision: string | null | undefined): boolean {
  const key = matchKey(decision);
  if (key === null) return false;
  return key !== REVIEW_APPROVED;
}

export function buildReviewNotice(
  decision: string | null | undefined
): ReviewNotice | null {
  const key = matchKey(decision);
  if (key === null) return null;
  if (key === REVIEW_APPROVED) return null;

  if (key === REVIEW_REJECTED) {
    return {
      known: true,
      blocking: true,
      title: 'Account rejected by Meta',
      detail:
        'Meta reviewed this WhatsApp account and rejected it for not meeting its ' +
        'policy requirements, so it cannot send messages. Review the decision in ' +
        'Meta Business Support Home, where you can also appeal.',
    };
  }

  if (key === REVIEW_PENDING) {
    return {
      known: true,
      blocking: true,
      title: 'Account under review by Meta',
      detail:
        'Meta is reviewing this WhatsApp account. It cannot send messages until ' +
        'the review finishes. No action is needed from you.',
    };
  }

  if (key === REVIEW_DEFERRED) {
    return {
      known: true,
      blocking: true,
      title: 'Meta deferred its review decision',
      detail:
        'Meta has postponed its review decision for this WhatsApp account. It ' +
        'cannot send messages until the review finishes.',
    };
  }

  const shown = typeof decision === 'string' ? decision.trim() : '';
  return {
    known: false,
    blocking: true,
    title: 'Account review update from Meta',
    detail:
      `Meta reported a review change on this WhatsApp account${
        shown ? ` (${shown})` : ''
      }. Sending may be unavailable. Check Meta Business Support Home for details.`,
  };
}
